import { useGetMe } from '@vimeo/gctl-api/hooks/useMe';
import { formatBytes } from '@vimeo/subscription-api-plans-data-hook';

export function useCurrentStorageLimit() {
  const { data, ...requestState } = useGetMe({
    select: ['uploadQuota'],
  });

  const max = data?.uploadQuota?.space?.max;
  const unit = data?.uploadQuota?.space?.unit;
  const restrictedMax = data?.uploadQuota?.restricted?.max;
  const restrictedUnit = data?.uploadQuota?.restricted?.unit;
  let currentStorageLimit = '';
  let currentRestrictedStorageLimit = '';

  if (max !== null && max !== undefined && max > 0) {
    if (unit === 'video_count') {
      currentStorageLimit = `${max}`;
    } else if (unit === 'video_size') {
      currentStorageLimit = formatBytes(max, false);
    }
  }

  if (restrictedMax !== null && restrictedMax !== undefined && restrictedMax > 0) {
    if (restrictedUnit === 'video_size' || restrictedUnit === undefined) {
      currentRestrictedStorageLimit = formatBytes(restrictedMax, false);
    }
  }

  return { currentStorageLimit, currentRestrictedStorageLimit, ...requestState };
}
